var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHeartFilled = function SvgHeartFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.034,
    height: 23,
    "data-name": "Group 619"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "heart-filled_svg__b"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#heart-filled_svg__b)",
    "data-name": "Group 240"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#73a6b7",
    d: "M24.135 2.259a6.557 6.557 0 0 0-10.47.753 10 10 0 0 0-.648 1.051 10 10 0 0 0-.648-1.051A6.557 6.557 0 0 0 1.9 2.259 7.9 7.9 0 0 0 0 7.5a9.66 9.66 0 0 0 2.662 6.341 59 59 0 0 0 6.661 6.224c1.007.859 2.049 1.746 3.158 2.717l.033.029a.76.76 0 0 0 1 0l.033-.029a316 316 0 0 1 3.159-2.717 59 59 0 0 0 6.661-6.224A9.66 9.66 0 0 0 26.034 7.5a7.9 7.9 0 0 0-1.9-5.241",
    "data-name": "Path 43"
  }))));
};
export default SvgHeartFilled;